import React from "react";
import styled from "styled-components";

const StyledSpinner = styled.div`
  display: inline-block;
  width: 70px;
  text-align: center;
  padding: 0.1rem;

  & > div {
    width: 10px;
    height: 10px;
    background-color: ${props => props.theme.colors.gray1};

    border-radius: 100%;
    display: inline-block;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .bounce1 {
    animation-delay: -0.32s;
  }

  .bounce2 {
    animation-delay: -0.16s;
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;

const Spinner: React.FC = () => (
  <StyledSpinner>
    <div className="bounce1" />
    <div className="bounce2" />
    <div className="bounce3" />
  </StyledSpinner>
);

export default Spinner;
